import { Drawer, 
         Toolbar, 
         Typography, 
         Divider, 
         List, 
         Box, 
         IconButton 
       }                                                  from "@mui/material"
import ChevronLeftIcon                                    from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon                                   from '@mui/icons-material/ChevronRight';
import SettingsOutlinedIcon                               from '@mui/icons-material/SettingsOutlined';
import { UtilityDrawer }                                  from "./UtilityDrawer";
import { PilotDrawer }                                    from "./PilotDrawer";
import { useLocation }                                    from "react-router";
import { useGlobalConfig }                                from "context/GlobalContext";
import LastPageIcon                                       from '@mui/icons-material/LastPage';
import FirstPageIcon                                      from '@mui/icons-material/FirstPage';
import LogoutOutlinedIcon                               from '@mui/icons-material/LogoutOutlined';


export type BglDrawerProps = {
  drawerWidth     : number,
  isExpanded      : boolean,
  onToggle        : () => void,
}

export const DrawerLayout = ({
    drawerWidth,
    isExpanded,
    onToggle,
  } : BglDrawerProps) => {

  const location = useLocation()
  const { rc } = useGlobalConfig()

  const navToHome = () => {
    rc.uiRouter.navigateToHome()
  }

  const getDynamicTitle = () => {
    const pathname = location.pathname
    
    // Project/Utility routes
    if (pathname.startsWith('/project/list')) {
      return 'Projects List'
    }
    if (pathname.startsWith('/project/create')) {
      return 'Projects List'
    }
    if (pathname.startsWith('/project/edit')) {
      return 'Delivery Project'
    }
    if (pathname.startsWith('/project/details')) {
      return 'Delivery Project'
    }
    if (pathname.startsWith('/pilot/configs')) {
      return 'Delivery Project'
    }
    if (pathname.startsWith('/pilot/assistant')) {
      return 'Delivery Project'
    }
    
    // Pilot routes
    if (pathname.startsWith('/pilot/')) {
      return 'Project Studio'
    }
    
    // Utility routes
    if (pathname.startsWith('/utility/')) {
      return 'Utilities'
    }
    
    // Recommendations routes
    if (pathname.startsWith('/reco/')) {
      return 'Recommendations'
    }
    
    // Workflow routes
    if (pathname.startsWith('/workflow/')) {
      return 'Workflows'
    }
    
    // Environment routes
    if (pathname.startsWith('/environment/')) {
      return 'Administration'
    }
    
    // Application Scope Master routes
    if (pathname.startsWith('/application-scope-master/')) {
      return 'Administration'
    }
    
    // Global Data Scenarios routes
    if (pathname.startsWith('/global-data-scenarios/')) {
      return 'Administration'
    }
    
    // Default fallback
    return 'Console'
  }

  const getDrawerComponent = () => {

    const pathname = location.pathname
    if (pathname.startsWith('/project/list') || 
        pathname.startsWith('/project/create') ||
        pathname.startsWith('/project/edit') ||
        pathname.startsWith('/workflow') ||
        pathname.startsWith('/environment') ||
        pathname.startsWith('/application-scope-master') ||
        pathname.startsWith('/global-data-scenarios')) {
      return (
        <UtilityDrawer
          isExpanded={isExpanded}
        />
      )

    } else {
      return (
        <PilotDrawer
          isExpanded={isExpanded}
        />
      )
    }
  }
 
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        transition: 'width 0.2s ease-in-out',
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          transition: 'width 0.2s ease-in-out',
          overflowX: 'hidden',
          position: 'relative',
        },
      }}
      variant="permanent"
      anchor="left">
      <Toolbar disableGutters onClick={navToHome} sx={{ cursor : 'pointer', display: 'flex', alignItems: 'center', paddingLeft: '14px',backgroundColor: '#061423', }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SettingsOutlinedIcon sx={{ fontSize : '30px', color : '#009999' }}/>
          {isExpanded && <Typography sx={{fontSize : '20px', fontWeight : 600, marginLeft : '10px', color: "white"}}>{getDynamicTitle()}</Typography>}
          <Box sx={{  
        display: 'flex', 
        justifyContent: 'center',
        padding: '16px',
        backgroundColor: 'inherit',
        // borderTop: '1px solid rgba(255, 255, 255, 0.12)'
      }}>
        {isExpanded && (
        <IconButton 
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onToggle();
          }} 
          sx={{ 
            border: '1px solid #ffffff',   // border color
            borderRadius: 1,               // square with small rounding
            padding: `1px`,
            color: '#cfd8dc',              // icon color
            '&:hover': {
              backgroundColor: '#1c2632',
            }
          }}
        >
          <LastPageIcon sx={{ width: 12, height: 12 }}/>

          {/* {isExpanded ? <ChevronLeftIcon /> : <ChevronRightIcon />} */}
        </IconButton>
        )}
      </Box>
        </Box>
      </Toolbar>
      <Divider />
      <List component="nav" sx={{ flexGrow: 1,backgroundColor: '#061423',p:1 }}>
        {getDrawerComponent()}
      </List>

      <Box sx={{ display: 'flex', padding: '16px',flexDirection: 'column', alignItems: isExpanded ? 'flex-start' : 'center', gap: 4,backgroundColor: '#061423',}}>


      {!isExpanded && (
        <IconButton 
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onToggle();
          }} 
          sx={{ 
            width: 24,
            height: 24,
            border: '1px solid #ffffff',   // border color
            borderRadius: 1.5,               // square with small rounding
            padding: `1px`,
            color: '#cfd8dc',              // icon color
            '&:hover': {
              backgroundColor: '#1c2632',
            }
          }}
        >
          <FirstPageIcon sx={{ width: 14, height: 14 }}/>
        </IconButton>
        )}
        <Box sx={{ display: 'flex', gap: 2,justifyContent:"center",alignItems:"center" }}>  
          <IconButton sx={{ '&:hover': {backgroundColor: '#1c2632'}}}>
            <LogoutOutlinedIcon sx={{color:"white",width: 16, height: 16}}  />
          </IconButton>
          {isExpanded && <Typography sx={{ fontSize: '14px', color: '#cfd8dc' }}>Log Out</Typography>}
         </Box>
        </Box>
    
    </Drawer>
  )
}